import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { DoorPrice } from '../models/doorPrice.model';
import { StartupService } from './startup.service';
import { DoorHandleType } from '../enums/doorHandleType.enum';
import { HingeType } from '../enums/hingeType.enum';
import { DoorPriceRequest } from '../interfaces/door-price-request.interface';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly _apiPrefix = environment.backendUrl;
  private readonly _customHeaders: HttpHeaders;

  constructor(
    private httpClient: HttpClient,
    private startupService: StartupService
  ) {
    this._customHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' });
  }

  public getUrlPrefix() {
    return this._apiPrefix;
  }

  public getOptions(responseType = 'json'): any {
    return {
      observe: 'response',
      headers: this._customHeaders,
      responseType,
    };
  }

  public post(partialUrl: string, body: any, responseType = 'json'): Observable<any> {
    let url = this.getUrlPrefix() + partialUrl;
    if (this.startupService.token) {
      url = url + '?token=' + this.startupService.token;
    }
    return this.httpClient.post(url, body, this.getOptions(responseType));
  }

  get<T>(partialUrl: string): Observable<T> {
    let url = this.getUrlPrefix() + partialUrl;
    if (this.startupService.token) {
      url = url + '?token=' + this.startupService.token;
    }
    return this.httpClient.get<T>(url);
  }

  getDoorPrice(
    type: string,
    height: number,
    width: number,
    isFreezer: boolean,
    interiorFinish: string,
    exteriorFinish: string,
    doorHandleType: DoorHandleType,
    hingeType: HingeType
  ): Observable<DoorPrice> {
    let url = this.getUrlPrefix() + 'api/prices/doors/';
    const request = {
      doorHandleType,
      exteriorFinish,
      height,
      hingeType,
      interiorFinish,
      isFreezer,
      type,
      width,
    } as DoorPriceRequest;
    if (this.startupService.token) {
      url = url + '?token=' + this.startupService.token;
    }
    return this.httpClient.post<DoorPrice>(url, request);
  }
}
